<script>
import AppNavbar from '@/components/AppNavbar'
import ArticleCover from '@/components/ArticleCover'
import ArticleMore from '@/components/ArticleMore'
import shareMixin from '@/mixins/shares'

export default {
	name: 'Article1',
	components: {
		AppNavbar,
		ArticleCover,
		ArticleMore,
	},
	mixins: [shareMixin],
	head: {
		title: {
			inner: 'Кто есть кто в мире «Ходячих мертвецов»'
		},
		meta: [
			{p: 'og:title', c: 'Афиша Zombie: кто есть кто в мире "Ходячих мертвецов"'},
			{p: 'og:description', c: 'Группа Рика, "Спасители", группа из Хилтопа, Королевство, и загадочные Мусорщики.' },
			{p: 'og:image', c: '/static/share/1.jpg'},
			{p: 'og:site_name', c: 'Афиша Zombie'},
		]
	}
}
</script>



<template>
<div class="article">
	<app-navbar />
	<article-cover image="main/story1.jpg">
		<h2 slot="title">Кто есть кто в мире «Ходячих мертвецов»</h2>
		<p slot="text">«Спасители», группа из Хилтопа, Королевство и Мусорщики</p>
	</article-cover>

	<section class="text start">
		<div class="inner">

			<h2>На случай если вы оказались в мире сериала впервые, вот расклад основных сил среди живых: плохие и хорошие, злые и добрые, а также те, кто еще не определился. Выбор за вами!</h2>

			<h3>Группа Рика</h3>

			<p>
				Переживший за семь сезонов множество злоключений, смертей и перетасовок коллектив, который возглавляет бывший полицейский Рик Граймс. К началу восьмого сезона от бывшей группы практически ничего не осталось — все разбрелись кто куда или погибли. Правой рукой Рика стала Мишонн, с которой у него завязался роман.
				<br>
				Мастерски владеющая японским мечом катаной, она и сама могла бы возглавить группу, но продолжает верить в то, что после падения злодея Нигана людям нужен будет новый лидер. Рик все еще отказывается им быть. Также в группу входят: возмужавший сын Рика Карл, спасшийся из плена Дэрил, девушки Тара и Росита, священник Гэбриел, ищущая покоя Кэрол, старый приятель Морган и — в какой-то степени — Мэгги, которая к восьмому сезону возглавила группировку из Хиллтопа.
			</p>

			<img class="article-image" src="../assets/articles/1/1.jpg">

		</div>
	</section>

	<section class="text">
		<div class="inner">

			<h3>Александрия</h3>

			<p>
				Большая, хорошо укрепленная община, ставшая новым местом жительства для группы Рика, которую сюда привел вербовщик Аарон. С приходом главных героев на общину свалились настоящие невзгоды — сначала из-за нападений секты по прозвищу Волки, а затем в лице узурпатора Нигана и его людей. Тем не менее Рик и его товарищи значительно увеличили обороноспособность Александрии, научили местных жителей сражаться и даже смогли организовать восстание против власти Нигана. Самые яркие обитатели Александрии: гей-пара Аарон и Эрик и инженер Юджин, который, правда, уже перебрался в Святилище.
			</p>

			<img class="article-image" src="../assets/articles/1/2.jpg">

		</div>
	</section>

	<section class="text">
		<div class="inner">

			<h3>Спасители</h3>

			<p>
				Преступная сеть рэкетиров и головорезов, которая держит в страхе все другие общины в округе. Спасителями правит авторитарный лидер Ниган, при котором все живут по балльной системе, преклоняют колени и беспрекословно подчиняются. Размахивая своей битой по прозвищу Люсиль, Ниган знает, как сломать психику любому и довести до животного страха даже такого сильного человека, как Рик. Основная база Спасителей называется Святилищем. Сюда свозят все припасы, которые банды отнимают у местных общин в качестве оброка и договора о ненападении. Спасители работают в связке с Мусорщиками, обирают Королевство, Хиллтоп и Александрию. Но после того как в конце седьмого сезона группа Рика организовала восстание этих общин, отступивший Ниган пообещал устроить им настоящую войну.
			</p>

			<img class="article-image" src="../assets/articles/1/3.jpg">

		</div>
	</section>

	<section class="text">
		<div class="inner">

			<h3>Мусорщики</h3>

			<p>
				Небольшая группа выживших, которые нашли пристанище прямо на свалке по соседству с Александрией. Лидером значится женщина по имени Джедис, которая вела двойную игру против группы Рика: сначала Мусорщики пообещали помочь ему в битве со Спасителями, но в последний момент выяснилось, что эти предатели всегда работали на Нигана. Предпочитают передвигаться на мусоровозах.
			</p>

			<img class="article-image" src="../assets/articles/1/4.jpg">

		</div>
	</section>

	<section class="text">
		<div class="inner">

			<h3>Королевство</h3>

			<p>
				Утопическое место жительства нескольких десятков людей, которыми правит король по имени Иезекииль. Жители общины битвам и грабежам предпочитают образование, чтение и просвещение. У них есть хор, кинотеатр и школа. Местные воины в своеобразных пластиковых латах ездят на лошадях и используют против зомби копья. Всадники Королевства в итоге пришли на выручку Александрии в битве со Спасителями. Некоторое время в Королевстве прожили Кэрол и Морган: поначалу Кэрол не могла воспринимать всерьез местный уклад жизни, но все-таки вкусные пироги и искренняя доброта Иезекииля ее подкупили.
			</p>

			<img class="article-image" src="../assets/articles/1/5.jpg">

		</div>
	</section>

	<section class="text">
		<div class="inner">

			<h3>Хиллтоп</h3>

			<p>
				Община в здании бывшего краеведческого музея, которую возглавлял старик по имени Грегори, но потом, во многом из-за более сильного и решительного характера, его место заняла Мэгги из группы Рика. Мэгги убедила местных жителей дать отпор рэкету Спасителей и восстать против несправедливости. Один из самых ярких представителей этого музейного царства — предприимчивый лидер общественного мнения, которого зовут Иисус — и выглядит он соответствующе своему имени.
			</p>

			<img class="article-image" src="../assets/articles/1/6.jpg">

		</div>
	</section>

	<section class="text">
		<div class="inner">

			<h3>Оушенсайд</h3>

			<p>
				Состоящая исключительно из женщин группа выживших, которая невероятно пострадала от рук Спасителей. Бандиты Нигана убили всех мужчин общины и хотели, чтобы женщины стали служить Спасителям. Однако тем удалось сбежать и укрыться глубоко в лесу, в лагере возле океанской бухты. В седьмом сезоне на них случайно натыкается Тара, которую поначалу встречают агрессивно, а затем приглашают стать частью Оушенсайда. Девицами руководит седовласая женщина по имени Натания, которая обучает всех военному мастерству и обращению с оружием. Больше всего община печется о том, чтобы об их существовании никто не узнал. Тара все-таки рассказывает об Оушенсайде группе Рика, и те решают позвать их на войну со Спасителями. Амазонки отказываются, хотя и позволяют забрать у них все оружие.
			</p>

			<img class="article-image" src="../assets/articles/1/7.jpg">

		</div>
	</section>

	<section class="text footer">
		<div class="inner">
			Смотреть сериал можно в «Интерактивном ТВ Ростелеком».
			<br>
			Если нашествие зомби застало вас не дома, подключайте опцию «Мультискрин» —<br>с ней весь контент будет доступен не только на экране телевизора,<br>но и <a href="https://moscow.rt.ru/inttv" target="_blank" onclick="ga('send', 'event', 'link', 'article', 'rostelekom')">на сайте itv.rt.ru</a> или на вашем мобильном устройстве.
		</div>
	</section>

	<div class="footer-share clearfix">
		<div class="title">Поделиться статьей</div>
		<a :href="shareFb" target="_blank" @click="shareClick('fb')"><i class="fa fa-facebook" aria-hidden="true"></i></a>
		<a :href="shareVk" target="_blank" @click="shareClick('vk')"><i class="fa fa-vk" aria-hidden="true"></i></a>
		<a :href="shareTg" target="_blank" @click="shareClick('tg')"><i class="fa fa-telegram" aria-hidden="true"></i></a>
		<a :href="shareTw" target="_blank" @click="shareClick('tw')"><i class="fa fa-twitter" aria-hidden="true"></i></a>
		<a :href="shareOk" target="_blank" @click="shareClick('ok')"><i class="fa fa-odnoklassniki" aria-hidden="true"></i></a>
	</div>

	<div class="devider"></div>

	<section class="text more">
		<div class="inner">Читайте также</div>
	</section>

	<article-more :ids="[6, 2, 3]" />


</div>
</template>



<style lang="less" scoped>
@import "../styles/colors.less";
@import "../styles/fonts.less";

.article {
	background: #fff;
}

section {
	width: 96%;
	max-width: 1040px;
	margin: 0 auto;
}

section .inner {
	max-width: 740px;
}

section h2 {
	padding: 0;
	margin: 0;
	font-weight: normal;
	font-size: 20px;
	padding-bottom: 20px;
	line-height: 30px;
}

section h3 {
	padding: 0;
	margin: 0;
	font-family: @fontLava;
	font-size: 18px;
	font-weight: bold;
	line-height: 27px;
}

section p {
	padding: 0;
	margin: 0;
	font-family: @fontLava;
	font-size: 18px;
	font-weight: normal;
	line-height: 27px;
}

.start {
	padding-top: 40px;
}

.text {
	background: #fff;
}

.article-image {
	width: 100%;
	max-width: 740px;
	padding: 40px 0;
}

.footer {
	padding: 40px 0;
	font-weight: 400;
	font-style: italic;
	font-family: @fontLava;
	line-height: 27px;
	font-size: 18px;

	a {
		color: @red;
	}
}

.footer-share {
	width: 100%;
	max-width: 1040px;
	margin: 0 auto;

	.title {
		width: 260px;
		height: 60px;
		line-height: 60px;
		font-size: 13px;
		letter-spacing: 1.5px;
		text-align: center;
		text-transform: uppercase;
		color: #fff;
		background: @red;
		float: left;
	}

	a {
		width: 80px;
		height: 60px;
		text-align: center;
		line-height: 60px;
		font-size: 20px;
		float: left;
		color: #fff;
		transition: opacity 200ms ease;
		background: #090909;
		transition: all 200ms ease;
		border-right: 1px solid #333333;
		box-sizing: border-box;
	}

	a:last-child {
		border-right: none;
	}

	a:hover {
		background: @red;
	}

}

.devider {
	width: 100%;
	height: 5px;
	background: #090909;
	margin-top: 60px;
}

.more {
	color: @red;
	font-size: 30px;
	height: 80px;
	line-height: 80px;
}





@media only screen
and (max-device-width: 640px),
only screen and (max-device-width: 736px),
only screen and (max-width: 480px) {


.footer-share {

	.title {
		display: none;
	}

	a {
		width: 20vw;
		height: 20vw;
		text-align: center;
		line-height: 20vw;
		font-size: 20px;
		float: left;
		color: #fff;
		transition: opacity 200ms ease;
		background: #090909;
		transition: all 200ms ease;
		border-right: 1px solid #333333;
		box-sizing: border-box;
	}

}

.devider {
	display: none;
}



}

</style>



// WEBPACK FOOTER //
// Article1.vue?4b1e84ef